@if (!!assignee) {
<span class="container">
  <span
    class="assignee"
    matTooltip="{{ assignee }}"
    matTooltipPosition="below"
    matTooltipClass="ellipsed-text-mattooltip"
  >
    {{ assignee }}
  </span>
</span>
} @else {
<span class="noData">Unassigned</span>
}
